<template>
  <div class="security-code-wrap">
    <div class="security" v-if="type=='security'">
      <label for="code">
        <ul class="security-code-container">
          <li class="field-wrap" v-for="(item, index) in number" :key="index">
            <i class="char-field">{{value[index]}}</i>
          </li>
        </ul>
      </label>
    </div>
    <div class="phone" v-if="type=='phone'">
      <div class="security-code" @click="chooseCountryClick">
        +{{area}}
        <img src="../../assets/images/jt6.png" />
      </div>
      <label for="code" style="flex: 1;">
        <ul class="security-code-container">
          <li
            class="field-wrap"
            :class="{'field-wrap-temp': index==2 ||index == 6}"
            v-for="(item, index) in number"
            :key="index"
          >
            <i class="char-field">{{value[index]}}</i>
          </li>
          <li class="closeTemp" v-if="show" @click="handleClick">
            <img src="../../assets/images/close.png" style=" width:0.13rem; height:0.13rem;" />
          </li>
        </ul>
      </label>
    </div>
      <input
      ref="input"
      class="input-code"
      @keyup="handleInput($event)"
      v-model="value"
      id="code"
      name="code"
      type="tel"
      :maxlength="number"
      autocorrect="off"
      autocomplete="off"
      autocapitalize="off"
    />
  </div>
</template>
<script>
export default {
  name: "SecurityCode",
  // component properties
  props: {
    number: {
      type: Number,
      default: 6
    },
    type: {
      type: String,
      default: "security"
    },
    code: {
      type: String,
      default: ""
    },
    areaCode: {
      type: String,
      default: ""
    },
  },
  // variables
  data() {
    return {
      value: "",
      telCode: this.code,
      show: false,
      area: ""
    };
  },
  mounted: function() {
    if (this.$route.query.area_code) {
      this.area = this.$route.query.area_code;
    } else {
      this.area = this.areaCode;
    }
  },
  watch: {
    value(n) {
      this.$emit("input", n);
      if (n.length > 0) {
        this.show = true;
        this.$nextTick(() => {
          //这里
          this.value = String(n).replace(/\D/g, "");
          // console.log(this.value);
        });
      } else {
        this.show = false;
      }
    },
    code: {
      handler(n) {
        this.value = n;
      },
      deep: true
    },
    areaCode: {
      handler(n) {
        this.area = n;
      },
      deep: true
    }
  },
  methods: {
    chooseCountryClick: function() {
      this.$router.push({
        path: "/country",
        query: {
          type: "inphone"
        }
      });
    },
    hideKeyboard: function() {
      // 输入完成隐藏键盘
      document.activeElement.blur(); // ios隐藏键盘
      this.$refs.input.blur(); // android隐藏键盘
    },
    handleInput: function(e) {
      this.$refs.input.value = this.value;
      if (this.value.length >= this.number) {
        this.hideKeyboard();
      }
    },
    handleClick: function() {
      this.value = "";
    }
  }
};
</script>
<style scoped lang="scss">
.security-code-wrap {
  overflow: hidden;
  position: relative;
}
.security {
  .security-code-container {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    .field-wrap {
      list-style: none;
      display: block;
      width: 0.66rem;
      height: 0.4rem;
      line-height: 0.4rem;
      font-size: 0.23rem;
      background-color: #fff;
      border-bottom: 0.01rem solid #5f6274;
      margin: 0.09rem;
      text-align: center;
      color: #000;
      .char-field {
        font-style: normal;
      }
    }
  }
}
.phone {
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  justify-content: center;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-justify-content: center;
  -o-justify-content: center;
  .security-code {
    font-size: 0.16rem;
    height: 0.41rem;
    line-height: 0.4rem;
    margin-right: 0.15rem;
    border-bottom: 1px solid #5f6274;
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -moz-flex;
    align-items: center;
    -webkit-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    -moz-align-items: center;
    img {
      width: 0.16rem;
      height: 0.16rem;
      padding: 0.06rem 0.05rem 0.06rem 0.03rem;
    }
  }
  .security-code-container {
    margin: 0;
    padding: 0;
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
    -moz-justify-content: flex-start;
    -ms-justify-content: flex-start;
    -o-justify-content: flex-start;
    border-bottom: 1px solid #5f6274;
    position: relative;
    .closeTemp {
      margin: 0.13rem 0.09rem;
      position: absolute;
      right: 0;
      top: 0;
    }
    .field-wrap {
      list-style: none;
      display: block;
      /*width: 0.4rem;*/
      height: 0.22rem;
      line-height: 0.22rem;
      font-size: 0.16rem;
      background-color: #fff;
      margin: 0.09rem 0;
      text-align: center;
      color: #000;
      .char-field {
        font-style: normal;
      }
    }
    .field-wrap-temp {
      padding-right: 0.1rem;
    }
  }
}

.input-code {
  opacity: 0;
  position: absolute;
  left: -999px;
  width: 100%;
  height: 0.1rem;
}
.codeWrap{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.15rem;
    .inputWrap{
      flex: 1 1 0%;
      position: relative;
      border-radius: 0.22rem;
      padding-left: 0.15rem;
      height: 0.44rem;
      line-height: 0.44rem;
      background: #F7F7F7;
      font-size: 0.16rem;
      color: #000;
      input{
        background:none;  
	      outline:none;  
    	  border:none;
      }
      img{
        width: 0.13rem;
        height: 0.13rem;
        position: absolute;
        top: 0;
        right: 0;
        margin: 0.15rem 0.09rem;
      }
    }
    .codeImg{
      height: 0.36rem;
      width: 34.5%;
      background: rgb(238, 238, 238);
      margin-left: 0.1rem;
      overflow: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/securityCode.vue